import axios from 'axios';

export const datasApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/datas`,
    headers: {
        'Content-Type': 'application/json'
    }
})